import React, { Fragment } from 'react';

import classnames from 'classnames';

import Button from '../Button/Button';
import Checkmark from './Checkmark';

import styles from './ProgressBar.scss';

const ProgressBar = ({
    goToStep,
    steps,
    value,
}) => (
    <span className={styles.steps}>
        {steps.map((step, index) => {
            const isActive = value === step;
            const isLess = index < steps.indexOf(value);
            const isLast = (index + 1) === steps.length;
            const onClick = () => goToStep(step);

            return (
                <Fragment key={step}>
                    <Button
                        className={classnames(styles.step, {
                            [styles.active]: isActive,
                        })}
                        disabled={!isLess}
                        onClick={onClick}
                        type='button'
                        unstyled
                    >
                        {isLess
                            ? <Checkmark className={styles.checkmark} />
                            : index + 1
                        }
                    </Button>
                    {!isLast && <span className={styles.line} />}
                </Fragment>
            );
        })}
    </span>
);

export default ProgressBar;
